import { defineComponent } from 'vue'
import { BlockModule } from '@/website/blocks/common'
import RedirectCountdown from './component/RedirectCountdown.vue'

new BlockModule({
    selector: '.egnc-redirect-countdown',
    vueComponent: defineComponent({
        components: {
            RedirectCountdown,
        },
        setup() {},
    }),
})
